import { useState } from "react";

export default function OPWDD() {
  const [openSection, setOpenSection] = useState(null);

  const containerStyle = {
    padding: "50px 20px",
    maxWidth: "1100px",
    margin: "0 auto",
    textAlign: "center"
  };

  const buttonWrapper = {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    flexWrap: "wrap",
    marginBottom: "25px"
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    padding: "20px",
    width: "320px",
    textAlign: "center"
  };

  const buttonStyle = {
    padding: "14px 26px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "none",
    color: "#2f6f89",
    fontWeight: "600",
    fontSize: "1.05rem",
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    cursor: "pointer",
    minWidth: "230px",
    width: "100%"
  };

  const descriptionStyle = {
    fontSize: "0.96rem",
    color: "#555",
    lineHeight: "1.5",
    marginTop: "14px",
    marginBottom: "0"
  };

  const downloadStyle = {
    display: "inline-block",
    marginBottom: "20px",
    padding: "12px 22px",
    backgroundColor: "#2f6f89",
    borderRadius: "10px",
    textDecoration: "none",
    color: "white",
    fontWeight: "600",
    fontSize: "0.95rem"
  };

  const pdfContainer = {
    width: "100%",
    height: "72vh",
    border: "1px solid #dbe1ea",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
    background: "#ffffff",
    marginBottom: "40px"
  };

  function toggleSection(sectionName) {
    setOpenSection((prev) => (prev === sectionName ? null : sectionName));
  }

  return (
    <section style={containerStyle}>
      <h1 style={{ fontSize: "2.2rem", color: "#2f6f89" }}>
        OPWDD Self-Direction Resources
      </h1>

      <p
        style={{
          fontSize: "1.1rem",
          marginTop: "10px",
          marginBottom: "35px",
          maxWidth: "700px",
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        Access commonly requested OPWDD Self-Direction information and documents.
      </p>

      <div style={buttonWrapper}>
        <div style={cardStyle}>
          <button
            onClick={() => toggleSection("broker")}
            style={buttonStyle}
          >
            {openSection === "broker" ? "Hide Broker List" : "Find a Broker"}
          </button>
          <p style={descriptionStyle}>
            Directory of approved OPWDD Support Brokers who assist participants
            and families with Self-Direction planning, budgets, staffing, and
            service coordination.
          </p>
        </div>

        <div style={cardStyle}>
          <button
            onClick={() => toggleSection("guide")}
            style={buttonStyle}
          >
            {openSection === "guide"
              ? "Hide Self-Direction Guide"
              : "Self-Direction Guide 2022"}
          </button>
          <p style={descriptionStyle}>
            Comprehensive guide explaining how OPWDD Self-Direction works,
            including available services, budgeting options, responsibilities,
            and steps to get started.
          </p>
        </div>
      </div>

      {openSection === "broker" && (
        <>
          <a
            href="/files/Support _Broker_List.pdf"
            download
            style={downloadStyle}
          >
            Download Broker List
          </a>

          <div style={pdfContainer}>
            <iframe
              src="/files/Support _Broker_List.pdf#zoom=page-width"
              title="Find a Broker"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          </div>
        </>
      )}

      {openSection === "guide" && (
        <>
          <a
            href="/files/SD_GUIDE_2022.pdf"
            download
            style={downloadStyle}
          >
            Download Self-Direction Guide
          </a>

          <div style={pdfContainer}>
            <iframe
              src="/files/SD_GUIDE_2022.pdf#zoom=page-width"
              title="Self-Direction Guide 2022"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          </div>
        </>
      )}
    </section>
  );
}